<div class="login-page d-flex">
  <div class="col-sm-5">
    <form class="login-content" id="main">
      @if (forgetPasswordSuccess) {
      <div class="forget-password">
        <div>
          <img
            [addAaTags]="'IN SOS logo'"
            src="/img/logo.png"
            class="login-logo m-auto"
            alt="Indiana Secretary of State Logo"
          />
        </div>
        <div>
          <img
            [addAaTags]="'Forget password image'"
            src="/img/forget-password.svg"
            class="m-auto"
            alt="Forget password image"
          />
        </div>
        <h1 class="login__primary-title">Check your email</h1>
        <div class="login__primary-sub_title text-center m-auto" aria-live="assertive"
        role="status">
          {{successMessage}}
        </div>
        <div class="grey d-flex relogin mt-3 justify-content-center">
          <p>Remember Password?</p>
          <a class="ps-2" (click)="back()" (keydown.enter)="back()" (keydown.space)="back()"> Login</a>
        </div>
      </div>
      } @else {
      <img [addAaTags]="'IN SOS logo'" src="/img/logo.png" class="login-logo" />
      <div class="login-inner">
        <div class="display--flex flex--justify-center mb-2">
          <h1 class="login__primary-title forgot-password__heading">
            <a
              class="pe-3"
              routerLink="/login"
              (keydown.enter)="back()"
              (keydown.space)="back()"
              aria-label="Go back to login"
              tabindex="1"
              ><img
                [addAaTags]="'Go back button'"
                src="/img/back.svg"
                alt=""
                aria-hidden="true"
            /></a>
            <span>Forgot Password?</span>
          </h1>
          <div class="login__primary-sub_title" [ngClass]="'ps-3'">
            Please provide your username/email ID to receive an email for
            resetting your password
          </div>
        </div>
        <div class="error-text" *ngIf="errorText">
          <img src="icons/linear/error-icon.svg" />
          <p>{{ errorText }}</p>
        </div>
        <div class="row mt-4">
          <app-input
            [index]="1"
            id="enter-username"
            [showLabel]="true"
            label="Username/Email"
            [required]="true"
            className="bg-light-blue"
            class="col-12 pb-15"
            placeholder="Enter Username/Email"
            [control]="emailControl"
          ></app-input>
          <app-button
            label="Send"
            type="primary"
            class="col-12 mt-2 w-100"
            (click)="resetPassword()"
            (keydown.enter)="resetPassword()"
            (keydown.space)="resetPassword()"

          ></app-button>
          <div class="d-flex relogin mt-3">
            <p>Remember Password?</p>
            <a
              class="ps-2"
              (click)="back()"
              (keydown.enter)="back()"
              (keydown.space)="back()"
              routerLink="/login"
            >
              Login</a
            >
          </div>
        </div>
      </div>
      }
    </form>
  </div>
  <div class="col-sm-7 side-image">
    <div class="background-image">
      <div class="login-header d-flex">
        <p>
          <a
            href="https://www.in.gov/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/img/in-logo.svg" [addAaTags]="'Indiana Logo'" />
          </a>
          <span class="mx-3"
            >An official application of the Indiana State Government</span
          >
        </p>
      </div>
    </div>
  </div>
</div>
